import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { ConfigAssDigitalDocumentoPaginadaDTO } from "types/dto/groupsign/ConfigAssDigitalDocumentoPaginadaDTO";
import { RequestConfigDocumentoGroupSign } from "types/request/groupSign/RequestConfigDocumentoGroupSign";

export const useGetConfigDocumentoPaginadas = (request: RequestConfigDocumentoGroupSign) => {
    const onSuccess = (response: any) => {
        return response;
      };

    return useFetch<Page<ConfigAssDigitalDocumentoPaginadaDTO>>({
        key: ["config-assinatura-digital", request],
        url: api.groupsign.configuracaoDocumentoAssinaturaDigital,
        params: request,
        onSuccess,
    });
};